import { Database, LineChart, Radar } from "lucide-react";

const SOURCES = [
  { icon: Database, name: "Solana RPC", desc: "Mint account, authorities, supply, Token-2022 extensions and creator transaction signatures.", basis: "Confirmed on-chain" },
  { icon: LineChart, name: "DexScreener", desc: "Prices, market cap, trading pairs, 24h volume, buy/sell counts and pool liquidity.", basis: "Market data" },
  { icon: Radar, name: "RugCheck", desc: "Indexed top holders, known pool/exchange labels, creator attribution, LP locks and wallet clusters.", basis: "Indexed / inferred" },
];

export const DataSources = () => (
  <section className="border-b border-trace-line bg-trace-panel py-24" data-testid="data-sources-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <p className="eyebrow">02 — Where the data comes from</p>
      <h2 className="mt-4 max-w-2xl text-3xl font-semibold tracking-[-0.02em] text-white sm:text-4xl">Every number has a source.</h2>
      <div className="mt-14 grid gap-px overflow-hidden rounded-xl border border-trace-line bg-trace-line md:grid-cols-3">
        {SOURCES.map((s, i) => (
          <div key={s.name} className="bg-trace-panel p-8" data-testid={`source-${s.name.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="flex items-center justify-between">
              <s.icon size={20} className="text-trace-green" />
              <span className="font-mono text-xs text-trace-dim">0{i + 1}</span>
            </div>
            <h3 className="mt-6 text-lg font-medium text-white">{s.name}</h3>
            <p className="mt-2 text-sm leading-relaxed text-trace-muted">{s.desc}</p>
            <p className="mt-5 font-mono text-[11px] uppercase tracking-wider text-trace-green/80">{s.basis}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
